import { obterMapasCotacaoAsync } from "../../services/mapaCotacaoService";

const atualizarMapasCotacao = async ({ commit }) => {
    const mapas = await obterMapasCotacaoAsync();
    commit('atualizarMapasCotacao', mapas);
}

const atualizarMapaCotacao = ({ commit }, mapa) => {
    commit('atualizarMapaCotacao', mapa);
}


const atualizarProdutosPreSelecionadosNovoMapa = ({ commit }, produtos) => {
    commit('atualizarProdutosPreSelecionadosNovoMapa', produtos);
}
const addMapaCotacao = ({ commit }, mapaCotacao) => {
    commit('addMapaCotacao', mapaCotacao);
}

const updateMapaCotacao = ({ commit }, mapaCotacao) => {
    commit('updateMapaCotacao', mapaCotacao);
}

export default {
    atualizarMapasCotacao,
    atualizarMapaCotacao,
    atualizarProdutosPreSelecionadosNovoMapa,
    addMapaCotacao,
    updateMapaCotacao
}
